import { Box, Grid, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { PricesStorageModel } from "e.sic-platform.webclient/src/services/shop/PricesStorage";
import { useCallback, useEffect, useState } from "react";
import { api } from "e.sic-platform.webclient/src/services/api/ApiService";
import ActivityPricesTable from "./components/ActivityPricesTable";
import CheckoutSuccessModal from "./components/CheckoutFinalizerModal";
import { activityPricesStorage } from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";
import CheckoutModal from "./components/CheckoutModal";
import CheckoutButton from "../../components/buttons/checkout-button/CheckoutButton";
import CoinPriceChart from "e.sic-platform.webclient/src/components/shop/CoinPriceChart";
import PriceStepper from "./components/PriceStepper";
import LoadingSpinner from "e.sic-platform.webclient/src/components/loading-spinner/LoadingSpinner";
import { orderStorage } from "e.sic-platform.webclient/src/services/shop/OrderStorage";
import { ChartInfoButton, CoinPricesTable } from "./components/CoinPricesTable";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { authentication } from "e.sic-platform.webclient/src/services/authentication/Authentication";

export default observer(function ShopPage() {
  // Balance being bought, in euro-cents.
  const coins = orderStorage.totalCents;

  const [pricesStorage] = useState(() =>
    PricesStorageModel.create({ noPagination: true }, { api, activityPricesStorage })
  );
  const [confirmationPending, setConfirmationPending] = useState(false);
  const [minReached, setMinReached] = useState(true);
  const [showPricesTable, setShowPricesTable] = useState(false);

  const checkout = useCallback(() => {
    pricesStorage.getCheckoutSessionUrl(coins);
  }, [coins]);

  useEffect(() => {
    setMinReached(coins >= activityPricesStorage.analysisPrice);
  }, [coins, pricesStorage.prices]);

  if (pricesStorage.isLoading) return <LoadingSpinner />;

  return (
    <Grid container alignItems="flex-start" className="centered">
      <Grid xs={12} xl={8} container>
        <CheckoutSuccessModal />
        <CheckoutModal
          confirmationPending={confirmationPending}
          setConfirmationPending={setConfirmationPending}
          onConfirm={checkout}
        />
        <Grid container rowSpacing={5} columnSpacing={5} className="centered">
          <Grid item xs={12} className="centered">
            <div
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <ChartInfoButton togglePanel={() => setShowPricesTable(!showPricesTable)} />

              <Box sx={{width: "100%", height: {xs: "50vh", sm: "45vw", lg: "33vw"}}}>
                <CoinPriceChart
                  coins={coins}
                  pricesStorage={pricesStorage}
                />
              </Box>
            </div>
          </Grid>
          <Grid item xs={11} sx={{display: {xs: "none", sm: "block"}}}>
            <PriceStepper
              pricesStorage={pricesStorage}
              coins={coins}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container xs={12} xl={4} spacing={1} className="centered" mt={1}>
        <Grid item xs={12} sm={9}>
          <ActivityPricesTable />
        </Grid>
        <Grid item xs={12} sm={showPricesTable ? 6 : 0} lg={12} className="centered">
          <CoinPricesTable open={showPricesTable} pricesStorage={pricesStorage} />
        </Grid>
        {authentication.anonymous && 
          <Grid item xs={12} className="centered">
            <Typography color="red">{translationService.translate("shop.firstOrder")}</Typography>
          </Grid>
        }
        <Grid item xs={12} className="centered">
          {/* Guests can browse prices freely; clicking checkout sends them to login and back here. */}
          <CheckoutButton
            disabled={!minReached}
            onClick={() =>
              authentication.anonymous
                ? authentication.loginToAccess("/shop")
                : setConfirmationPending(!confirmationPending)
            }
            textKey={authentication.anonymous ? "shop.authentication-needed" : "shop.checkout"}
          />
        </Grid>
      </Grid>
    </Grid>
  );
});
